import { Card, Button } from 'react-bootstrap';
import styled from 'styled-components';

export const StyledCard = styled(Card)`
  padding-top: 15px;
  display: flex;
  background: #fff;
  border-radius: 10px;
  border: none;
  box-shadow: 0px 0px 7px #efe7e7;
  p {
    padding: 0;
    margin: 0;
    color: #373a3c;
    font-size: 14.5px;
  }
  .label {
    width: fit-content;
    padding: 3px 18px;
    border-top-right-radius: 15px;
    border-bottom-right-radius: 15px;
    background-color: #ffbe00;
    font-size: 12px;
    color: #fff;
  }

  .pcd-label {
    position: absolute;
    right: 0;
    width: fit-content;
    padding: 3px 18px;
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
    background-color: #0b4d83;
    font-size: 12px;
    color: #fff;
  }

  span {
    color: #12793a;
    font-size: 15px;
  }
`;

export const CardHeader = styled(Card.Header)`
  display: flex;
  align-items: center;
  border-bottom: none;
  padding: 0px;
  background: #fff;
`;
export const CardTitle = styled(Card.Title)`
  color: #373a3c;
  margin: 5px 20px;
`;

export const CardButton = styled(Button)`
  border-radius: 25px;
  font-size: 12px;
  padding: 4px 10px;
  background-color: #12793a;
  border-color: #12793a;
  color: white;
  text-decoration: none;
  &:hover {
    background-color: #0b4d83;
    border-color: #0b4d83;
    text-decoration: none;
    color: white;
  }
`;

export const CardItem = styled.div`
  display: block;
  height: fit-content;
`;
